import {CommonModule} from '@angular/common';
import {NgModule, Pipe, PipeTransform} from '@angular/core';
import {isNullOrUndefined} from 'util';

@Pipe({
  name: 'iconfont'
})
export class IconfontPipe implements PipeTransform {
  transform (value: any, args?: any): any {
    if (!isNullOrUndefined(value)) {
      if (value.includes('&#x')) {
        value = value.replace('&#x', '');
        value = value.replace(';', '');
        value = String.fromCharCode(parseInt(value, 16));
      }
    }
    return value;
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [IconfontPipe],
  declarations: [IconfontPipe]
})
export class IconfontModule {
}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/pipes/iconfont.pipe.ts